import React from 'react';
import styled from 'styled-components';

const SocialFloatingLink = styled.a`
  position: fixed;
  right: ${({ $right }) => $right || 'var(--floating-ui-right, 1.5rem)'};
  bottom: ${({ $bottom }) => $bottom || 'var(--floating-action-slot-1, 1.5rem)'};
  z-index: ${({ $zIndex }) => $zIndex || 1000};
  display: flex;
  width: var(--floating-action-size, 48px);
  height: var(--floating-action-size, 48px);
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 999px;
  background: ${({ $background }) => $background || 'rgba(255, 255, 255, 0.92)'};
  color: ${({ $textColor }) => $textColor || '#111318'} !important;
  box-shadow: 0 13px 28px rgba(31, 36, 51, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.28);
  font-size: 1.45rem;
  white-space: nowrap;
  text-decoration: none !important;
  backdrop-filter: blur(16px) saturate(140%);
  -webkit-backdrop-filter: blur(16px) saturate(140%);
  transition: width 300ms cubic-bezier(0.22, 1, 0.36, 1), transform 220ms ease, box-shadow 220ms ease;

  svg {
    flex: 0 0 auto;
    color: ${({ $textColor }) => $textColor || '#111318'};
    transition: transform 260ms cubic-bezier(0.22, 1, 0.36, 1);
  }

  span {
    max-width: 0;
    overflow: hidden;
    margin-left: 0;
    opacity: 0;
    color: ${({ $textColor }) => $textColor || '#111318'};
    font-size: 0.76rem;
    font-weight: 760;
    letter-spacing: -0.01em;
    transition: max-width 260ms ease, margin-left 260ms ease, opacity 180ms ease;
  }

  &:hover,
  &:focus-visible {
    width: 128px;
    color: ${({ $textColor }) => $textColor || '#111318'} !important;
    box-shadow: 0 18px 38px rgba(31, 36, 51, 0.26), inset 0 1px 0 rgba(255, 255, 255, 0.32);
    transform: translateY(-3px);
    outline: none;
  }

  &:hover svg,
  &:focus-visible svg {
    transform: scale(1.06);
  }

  &:hover span,
  &:focus-visible span {
    max-width: 76px;
    margin-left: 9px;
    opacity: 1;
  }

  @media (max-width: 768px) {
    display: ${({ $hideOnNarrow }) => ($hideOnNarrow ? 'none' : 'flex')};
    font-size: 1.3rem;

    &:hover,
    &:focus-visible {
      width: var(--floating-action-size, 44px);
      transform: translateY(-2px);
    }

    &:hover span,
    &:focus-visible span {
      max-width: 0;
      margin-left: 0;
      opacity: 0;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

const SocialFloatingButton = ({
  href,
  icon: IconComponent,
  text,
  bottom,
  right,
  background,
  textColor,
  zIndex,
  ariaLabel,
  openInNewTab = true,
  onClick,
  hideOnNarrow = false,
}) => {
  const handleClick = (event) => {
    if (onClick) {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <SocialFloatingLink
      href={href || '#'}
      target={openInNewTab ? '_blank' : '_self'}
      rel={openInNewTab ? 'noopener noreferrer' : ''}
      $bottom={bottom}
      $right={right}
      $background={background}
      $textColor={textColor}
      $zIndex={zIndex}
      $hideOnNarrow={hideOnNarrow}
      aria-label={ariaLabel}
      onClick={handleClick}
    >
      {IconComponent && <IconComponent aria-hidden="true" />}
      <span>{text}</span>
    </SocialFloatingLink>
  );
};

export default SocialFloatingButton;
